export const getCheckoutUrl = () => {
  const url = '/checkout';

  return url;
};

export const defaultCheckoutUrl = () => '';
